export enum DemandAction {
  GetList = 'GET_LIST',
  ChangeActiveTab = 'CHANGE_ACTIVE_TAB',
  GetCounts = 'GET_COUNTS',
  GetCountsRun = 'GET_COUNTS_RUN',
  GetCountsStop = 'GET_COUNTS_RUN'
}
